import useTranslations from "@hooks/useTranslations";
import { SOCIAL_PROFILES } from "@data/social";
import SocialLinks from "@pages/SocialLinks";
import { ICONS } from "@utils/icons";

const PersonalInfo = () => {
  const t = useTranslations();

  return (
    <div className="col-xxl-4 col-xl-4 col-lg-4">
      <div className="bostami-parsonal-info-area">
        <div className="bostami-parsonal-info-img">
          <img
            src="/assets/img/parsonal-info/profile.jpg"
            alt="Victorien ANDRIANASOAVINA"
            width="250"
            height="250"
          />
        </div>
        <h4 className="bostami-parsonal-info-name">Victorien ANDRIANASOAVINA</h4>
        <span className="bostami-parsonal-info-bio mb-15">
          {t.personalInfo.bio}
        </span>
        <SocialLinks profiles={SOCIAL_PROFILES} />
        <div className="bostami-parsonal-info-contact mb-30">
          <div className="bostami-parsonal-info-contact-item phone">
            <div className="icon">
              <i className={ICONS.phone} />
            </div>
            <div className="text">
              <span>{t.personalInfo.phone}</span>
              <p>+261 34 36 772 34</p>
            </div>
          </div>
          <div className="bostami-parsonal-info-contact-item email">
            <div className="icon">
              <i className={ICONS.email} />
            </div>
            <div className="text">
              <span>{t.personalInfo.email}</span>
              <p className="text-lowercase">andriavict@gmail.com</p>
            </div>
          </div>
          <div className="bostami-parsonal-info-contact-item location">
            <div className="icon">
              <i className={ICONS.location} />
            </div>
            <div className="text">
              <span>{t.personalInfo.address}</span>
              <p>IVF 167 ter Anosisoa, Ambohimanarina, Antananarivo</p>
            </div>
          </div>
        </div>
        <div className="bostami-parsonal-info-btn">
          <a
            className="btn-2 circle"
            href="/cv.pdf"
            download="CV_Victorien_Andrianasoavina.pdf"
          >
            <span className="icon">
              <i className={ICONS.download} />
            </span>
            {t.personalInfo.downloadCV}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
